import React, { FunctionComponent } from 'react';

import { ButtonProps, default as MuiButton } from '@mui/material/Button';

const Button: FunctionComponent<ButtonProps> = ({
  children,
  color,
  disabled,
  fullWidth,
  size,
  type,
  variant,
  onClick,
  sx,
  className,
}: ButtonProps) => {
  return (
    <MuiButton
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      type={type}
      variant={variant}
      onClick={onClick}
      sx={sx}
      className={className}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
